var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-tabs",
        {
          staticClass: "fit",
          attrs: { "no-pane-border": "", align: "center" }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              default: "",
              name: "details",
              label: "Details"
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: { slot: "title", name: "role", label: "Sessions" },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: { slot: "title", name: "documents", label: "Documents" },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: { slot: "title", name: "notes", label: "Notes" },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { staticClass: "fit", attrs: { name: "details" } },
            [_c("class-details-tab")],
            1
          ),
          _c("q-tab-pane", { staticClass: "fit", attrs: { name: "sessions" } }),
          _c("q-tab-pane", {
            staticClass: "fit",
            attrs: { name: "documents" }
          }),
          _c("q-tab-pane", { staticClass: "fit", attrs: { name: "notes" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }